module.exports = __webpack_public_path__ + "static/media/img_4.21f71925.jpg";